import './Subscriptions.scss';
import { useData } from '../../context/subscriptionsContext';
import { useAuth } from '../../context/AuthProvider';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const api = process.env.REACT_APP_API_URL;

function Subscriptions({program}) {
    const navigate = useNavigate();

    const subscriptions = useData().data;
    const roles = subscriptions.find(p => p.id === program)?.roles;

    const { user } = useAuth();

    const [role, setRole] = useState(null);

    const toPayment = async (e, tier, roleID) => {
        e.preventDefault();

        e.target.disabled = true;

        if(!user) {
            toast.error("You need to be logged in to subscribe.");
            navigate('/user/signin');
            return;
        }

        let userID, stripeCID;

        await axios.post(`${api}/user/dashboard/${program}`, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("auth_token")}`
            }
        }).then(response => {
            userID = response.data.data.id;
            stripeCID = response.data.data.stripe_customer_id;
        });

        const res = await axios.post(`${api}/stripe/create-checkout-session`, {
            userID: userID ,
            stripeCID: stripeCID || null,
            priceID: roles.find(t => t.id === tier).price_id,
            coupon: roles.find(t => t.id === tier).coupon,
            trial_period_days: roles.find(t => t.id === tier).free_trial_days,
            programID: program,
            tier: tier
        });

        window.location.href = res.data.url;
    }

    useEffect(() => {
        if (!user) return;

        axios.post(`${api}/user/get/role`, { program }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("auth_token")}`
            }
        })
        .then(response => {
            setRole(response.data.role);
        })
        .catch(error => {
            console.error("Error fetching user role:", error);
            setRole(null);
        });
    }, [user, program]);

    return (
        <div className='subscriptions'>
            {roles.map((t, index) => (
                <div className={"card " + (t.isHighlighted ? 'highlighted' : "")} key={index}>
                    {t.free_trial_days ? (<div className='trial'>{t.free_trial_days} days free trial!</div>) : null}
                    <div className='title'>{t.name}</div>
                    {t.price_text ? (<div className='price-text'>{t.price_text}</div>) : null}
                    <div className='price'>
                        {t.old_price ? <span className='old'>${t.old_price}</span> : null}
                        <span className='current'>${t.price}</span>
                    </div>
                    <div>{t.description}</div>
                    <ul className='list features'>
                        {t.features && t.features.map((feature, idx) => (
                            <li key={idx}>{feature}</li>
                        ))}
                    </ul>
                    {
                        !user || !role ?
                            <Link to="/user/signin" className={'btn' + (t.isHighlighted ? ' primary' : '')}>Get Started</Link>
                        : role === t.id ?
                            <span className='current-plan'>Current Plan</span>
                        : role !== 'role0' ?
                            <Link to="/user/dashboard" className={'btn' + (t.isHighlighted ? ' primary' : '')}>Change Plan</Link>
                        :
                            <button className={'btn' + (t.isHighlighted ? ' primary' : '')} onClick={(e) => toPayment(e, t.id)}>Get Started</button>
                    }
                </div>
            ))
            }
        </div>
    )
}

export default Subscriptions